import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Global handler: close SweetAlert2 modals on Enter
window.addEventListener('keydown', (e: KeyboardEvent) => {
  if (e.key === 'Enter' && document.body.classList.contains('swal2-shown')) {
    const confirmBtn = document.querySelector('.swal2-confirm') as HTMLElement | null;
    if (confirmBtn) {
      e.preventDefault();
      confirmBtn.click();
    }
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
